import { Col, Container, Row } from 'react-bootstrap';
import Config from '../config/config';
import Map from './map';
import './page.css';

export default function Contact() {
    return (
        <div>
            <Container>
                <ContactInfo contact={Config.CONTACT} />
                <Map info={Config.CONTACT} />
            </Container>
        </div>
    );
}

function ContactInfo({ contact }) {
    return contact.map((info, i) => (
        <Row className="justify-content-md-center" key={i}>
            <Col md={{ span: 4 }}>
                <span>{info}</span>
            </Col>
        </Row>
    ));
}
